import { render, staticRenderFns } from "./ExamAsDistToRegForm.vue?vue&type=template&id=2528f176&scoped=true&"
import script from "./ExamAsDistToRegForm.vue?vue&type=script&lang=js&"
export * from "./ExamAsDistToRegForm.vue?vue&type=script&lang=js&"
import style0 from "./ExamAsDistToRegForm.vue?vue&type=style&index=0&id=2528f176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528f176",
  null
  
)

export default component.exports